<div *ngIf="area" class="container-fluid">
    <form #form="ngForm" (ngSubmit)="saveArea(form)">
        <div mat-dialog-title>
            <div *ngIf="area.area_ID" i18n>Edit Area</div>
            <div *ngIf="!area.area_ID" i18n>Add Area</div>
        </div>

        <div mat-dialog-content>
            <div class="form-inline mb-3">
                <span *ngIf="!area.area_ID" i18n>To add a new Area, complete the form below then click Submit.</span>
                <span *ngIf="area.area_ID" i18n>Make the necessary changes on the form below then click Submit</span>
                <span class="float-right warning col-sm-4" i18n>* Required Information</span>
            </div>

            <div class="form-group form-inline">
                <ng-container *ngIf="area.area_IsOption; then optionsNameArea; else defaultNameArea"></ng-container>
                <ng-template #defaultNameArea>
                    <span class="warning">* </span>
                    <label class="col-form-label pr-2" for="name" i18n>Area Name</label>

                    <div class="col-md-6">
                        <input id="name" name="name" class="form-control  col-md-12" [(ngModel)]="area.area_Name"
                               required #name="ngModel"
                               [class.field-error]="form.submitted && name.invalid">
                        <div [hidden]="!form.submitted || name.valid"
                             class="alert alert-danger" i18n>
                            Area Name is required
                        </div>
                    </div>
                </ng-template>
                <ng-template #optionsNameArea>
                    <label class="col-form-label pr-2" for="name" i18n>Area Name</label>
                    <div class="col-md-6">
                        {{area.area_Name}}
                    </div>
                </ng-template>
            </div>

            <div class="form-group form-inline">
                <ng-container *ngIf="area.area_IsOption; then optionsDescArea; else defaultDescArea"></ng-container>
                <ng-template #defaultDescArea>
                    <label class="col-form-label pr-2" for="areaDesc">Description</label>
                    <div class="col-md-10">
                        <textarea id="areaDesc" name="areaDesc" type="text"
                                  class="form-control col"
                                  [(ngModel)]="area.area_Desc"
                                  #areaDesc="ngModel"></textarea>
                    </div>
                </ng-template>
                <ng-template #optionsDescArea>
                    <label class="col-form-label pr-2" for="areaDesc" i18n>Description</label>
                    <div class="col-md-10">
                        {{area.area_Desc}}
                    </div>
                </ng-template>
            </div>
            <div class="form-group form-inline" *ngIf="!addAccessories">
                <label class="col-form-label pr-2" for="accessories" i18n>Area Accessories</label>
                <div class="col-sm-10">
                    <button type="button" [disabled]="isRequesting" class="btn btn-bidit-action btn-md"
                            title="Remove accessory"
                            i18n-title
                            (click)="showAddAccessory()" i18n>
                        Add
                    </button>
                </div>
                <div *ngFor="let selectedAccessory of selectedAreaAccessories" class="col-sm-10">
                    {{selectedAccessory.item_Name}}
                    <button type="button" class="ml-2 btn btn-bidit-delete" (click)="removeAccessory(selectedAccessory.item_ID)"></button>
                </div>
            </div>
            <div class="form-group form-inline" *ngIf="addAccessories">
                <label class="col-form-label pr-2" for="accessories" i18n>Filter Accessories</label>
                <div class="col-sm-10">
                    <span i18n>Filter:</span>
                    <input type="text" style="width: 600px;"
                           class="form-control"
                           autocomplete="nope"
                           aria-label="Number"
                           matInput
                           [formControl]="accessoryControl" />
                </div>
                <div class="accessory-list">
                    <div *ngFor="let item of filteredAccessoryItems | async">

                        <div class="form-inline">
                            <input type="checkbox" name="user_status_{{item.item_ID}}" id="user_status_{{item.item_ID}}" class="mr-1" [(ngModel)]="item.IsSelected">

                            {{item.item_Name}}
                        </div>
                    </div>
                </div>
                <button type="button" [disabled]="isRequesting" class="btn btn-bidit-action btn-md"
                        title="Remove accessory"
                        i18n-title
                        (click)="finishAccessories()" i18n>
                    Add Complete
                </button>
            </div>

            <div class="mt-3">
                <div [hidden]="!form.submitted || form.valid"
                     class="alert alert-danger" i18n>
                    Validation issues encountered.  Please review your entered information.
                </div>
            </div>
            <div *ngIf="errors" class="row alert alert-danger" role="alert">
                <strong>{{errors}}</strong>
            </div>
        </div>
        <mat-dialog-actions align="end">
            <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
            <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
        </mat-dialog-actions>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
    </form>
</div>
